// extracted by mini-css-extract-plugin
export default {"cls1":"RatingCard-cls1__hH","cls2":"RatingCard-cls2_Y2q RatingCard-cls1__hH"};